import { isTenantOwnerAdmin } from "utils/isTenantOwnerAdmin"
import React from "react"
import {
  Card,
  CardBody,
  Col,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { useEffect } from "react"
import {
  deleteCategory,
  getAllCategoriesList,
  updateCategoryStatus,
} from "store/actions/categoriesAction"
import { useState } from "react"
import Switch from "components/Shared/Switch"
import DeleteModal from "components/Common/DeleteModal"
import Filters from "components/Common/Filters"
import Paginations from "components/Common/Paginations"
import { showAlert } from "store/reducers/alertReducer"
import DataExportDropdown from "components/Shared/DataExportDropdown"
import isPermissionEnabled, {
  getSubPermissions,
} from "common/isPermissionEnabled"
import placeholderImage from "assets/images/placeholderImage.png"
import { pdfDownload } from "helpers/api_helper"
import DownloadXLSX from "components/Shared/DownloadXLSX"
import DownloadCSV from "components/Shared/DownloadCSV"
import { EXPORT_DATA } from "helpers/url_helper"
import TableShimmer from "components/Shared/TableShimmer"
import { useTranslation } from "react-i18next"
import MenuFilters from "components/Shared/MenuFilters"
import {
  setSelectedCountry,
  setSelectedBrand,
  setSelectedMenu,
} from "store/menuFilter/action"
import { useBrandOptions } from "hooks"
import ConfirmModal from "components/Common/ConfirmModal"

const Categories = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Categories List ")

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const pageNumber = parseInt(searchParams.get("page")) || 1
  const [selectedId, setSelectedId] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [itemIdToDelete, setItemIdToDelete] = useState(null)
  const [isApiCalled, setIsApiCalled] = useState(false)
  const { allowedBrands, hasOnlyOneBrand } = useBrandOptions()

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const {
    loading,
    isLoading,
    isUpdating,
    totalCount,
    itemsPerPage,
    currentPage,
    totalPages,
    categoriesLists,
  } = useSelector(state => state.Categories)

  const [searchTerm, setSearchTerm] = useState(searchParams.get("search") || "")
  const [selectedFilters, setSelectedFilters] = useState({
    status: parseInt(searchParams.get("status") || "2"),
    sortOrder: parseInt(searchParams.get("sortOrder") || "1"),
    countryCode: [],
  })

  const [usersPermissions, setUsersPermissions] = useState({
    list: null,
    create: null,
    edit: null,
    delete: null,
  })
  const [showStatusModal, setShowStatusModal] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState(null)

  const { userRole, accountType } = useSelector(state => state.Login)
  const { selectedCountry, selectedBrand, selectedMenu } = useSelector(
    state => state.MenuFilterReducer
  )

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = getSubPermissions(
      userRole,
      4,
      "menus_1",
      accountType
    )
    const isPermissionView = isPermissionEnabled(
      userRole,
      4,
      "menus_1",
      accountType
    )
    const isPermissionCreate = isPermissionEnabled(
      userRole,
      4,
      "menus_2",
      accountType
    )
    const isPermissionEdit = isPermissionEnabled(
      userRole,
      4,
      "menus_3",
      accountType
    )
    const isPermissionDelete = isPermissionEnabled(
      userRole,
      4,
      "menus_4",
      accountType
    )
    if (
      (!isTenantOwnerAdmin() &&
        !isPermissionList?.menu_full_access_view?.isEnabled) ||
      !isPermissionView
    ) {
      navigate("/dashboard")
    } else {
      getAllCategories()
    }
    setUsersPermissions({
      list: isPermissionList,
      create: isPermissionCreate,
      edit: isPermissionEdit,
      delete: isPermissionDelete,
    })
  }, [userRole, allowedBrands])

  useEffect(() => {
    getAllCategories()
  }, [selectedBrand, allowedBrands])

  const getAllCategories = () => {
    let brand = selectedBrand?.value
    const { status, sortOrder } = selectedFilters
    const payload = {
      perPage: itemsPerPage,
      pageNo: pageNumber,
      status: status,
      orderBy: sortOrder,
      keyword: searchTerm,
    }

    // check no brand
    if (allowedBrands?.length == 0) return

    // Check for one single brand
    if (hasOnlyOneBrand) brand = allowedBrands && allowedBrands[0]?._id

    if (selectedCountry) {
      payload.countryCode = [selectedCountry.value]
    }

    if (brand) {
      payload.brand = [brand]
    }
    if (selectedMenu) {
      payload.menu = [selectedMenu.value]
    }
    dispatch(getAllCategoriesList(payload))
    setIsApiCalled(true)
  }

  const filters = [
    {
      name: "status",
      type: "select",
      options: [
        { label: t("All"), value: 2 },
        { label: t("Active"), value: 1 },
        { label: t("Deactive"), value: 0 },
      ],
      placeholder: t("All"),
    },
    {
      name: "sortOrder",
      type: "select",
      options: [
        { label: t("Ascending"), value: 1 },
        { label: t("Descending"), value: 2 },
      ],
      placeholder: t("Ascending"),
    },
  ]

  const handleStatusClick = (id, status) => {
    setSelectedCategory({ id, status })
    setShowStatusModal(true)
  }

  const handleDelete = () => {
    const payload = {
      id: itemIdToDelete,
      status: "2", // for delete
    }
    dispatch(deleteCategory({ ...payload, setShowDeleteModal }))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleSearchChange = e => {
    setSearchTerm(e.target.value)
  }

  const handleSearch = () => {
    getApiCall(1)
  }

  // useEffect(() => {
  //   if (isApiCalled) {
  //     if (searchTerm) {
  //       const delayDebounceFn = setTimeout(() => {
  //         handleSearch()
  //       }, 500)

  //       return () => clearTimeout(delayDebounceFn)
  //     } else {
  //       handleSearch()
  //     }
  //   }
  // }, [searchTerm, selectedFilters])

  const handleFilterChange = (selectedValue, filterName) => {
    setSelectedFilters(prevFilters => ({
      ...prevFilters,
      [filterName]: selectedValue,
    }))
  }

  const handleReset = () => {
    setSearchTerm("")
    const payload = {
      perPage: 10,
      pageNo: 1,
      status: 2,
      orderBy: 1,
      keyword: "",
    }
    dispatch(getAllCategoriesList(payload))
    setSelectedFilters({
      status: 2,
      sortOrder: 1,
      countryCode: [],
    })
    setSearchTerm("")
    dispatch(setSelectedCountry(null))
    dispatch(setSelectedBrand(null))
    dispatch(setSelectedMenu(null))
    navigate(`/menus/categories`)
  }

  const onPageChange = page => {
    getApiCall(page)
  }

  const getApiCall = (page = 1) => {
    const { status, sortOrder } = selectedFilters // const updatedCountryCode = countryCode?.map(item => item.value) || []

    const searchParams = new URLSearchParams()
    searchTerm && searchParams.set("search", searchTerm)
    searchParams.set("status", status.toString())
    searchParams.set("sortOrder", sortOrder.toString())
    searchParams.set("page", page.toString())

    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      status: Number(status),
      orderBy: Number(sortOrder),
      keyword: searchTerm || "",
    }
    if (selectedCountry) {
      payload.countryCode = [selectedCountry.value]
    }
    if (selectedBrand) {
      payload.brand = [selectedBrand.value]
    }
    if (selectedMenu) {
      payload.menu = [selectedMenu.value]
    }

    dispatch(getAllCategoriesList(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          navigate(`/menus/categories?${searchParams.toString()}`)
        }
      })
      .catch(error => {
        console.error("Error fetching categories:", error)
      })
  }

  const handleExcelDownload = async () => {
    const { status } = selectedFilters

    const payload = {
      status: Number(status),
      keyword: searchTerm || "",
      type: "CATEGORY",
      exportType: "xlsx",
    }
    if (selectedCountry) {
      payload.countryCode = [selectedCountry.value]
    }
    if (selectedBrand) {
      payload.brand = [selectedBrand.value]
    }
    if (selectedMenu) {
      payload.menu = [selectedMenu.value]
    }
    const response = await pdfDownload(EXPORT_DATA, payload)
    if (response) {
      const xlsxData = response
      DownloadXLSX(xlsxData, t("Categories"))
    }
  }

  const exportToCSV = async () => {
    const { status } = selectedFilters

    const payload = {
      status: Number(status),
      keyword: searchTerm || "",
      type: "CATEGORY",
      exportType: "csv",
    }
    if (selectedCountry) {
      payload.countryCode = [selectedCountry.value]
    }
    if (selectedBrand) {
      payload.brand = [selectedBrand.value]
    }
    if (selectedMenu) {
      payload.menu = [selectedMenu.value]
    }
    const response = await pdfDownload(EXPORT_DATA, payload)
    if (response) {
      const csvData = response
      DownloadCSV(csvData, t("Categories"))
    }
  }

  const confirmStatusUpdate = () => {
    if (!selectedCategory) return
    const { id, status } = selectedCategory

    const payload = {
      id,
      status: status === 1 ? "0" : "1", // toggle active/deactive
    }

    dispatch(updateCategoryStatus(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(() => {})
      .finally(() => {
        setSelectedCategory(null)
        setShowStatusModal(false)
      })
  }

  return (
    <>
      <div className="page-content category_page">
        <div className="container-fluid">
          <Breadcrumbs />
          <MenuFilters />
          <Row>
            <Col xl={12}>
              <Card>
                <DataExportDropdown
                  cardTitle={t("Categories List")}
                  isAddBtn={usersPermissions.create}
                  addBtnText={t("Add Category")}
                  onAddBtnClick={() => navigate("/menus/categories/add")}
                  isExportData={loading ? false : true}
                  onDownloadCSV={exportToCSV}
                  onDownloadExcel={handleExcelDownload}
                />
                {/* {!loading && ( */}
                <CardBody>
                  <Filters
                    filters={filters}
                    searchTerm={searchTerm}
                    handleSearchChange={handleSearchChange}
                    handleFilterChange={handleFilterChange}
                    handleSearch={handleSearch}
                    onReset={handleReset}
                    selectedFilters={selectedFilters}
                    searchBy={t("Name")}
                    colSize={4}
                  />
                </CardBody>
                {/* )} */}
              </Card>
            </Col>
          </Row>
          <Row className="m-auto">
            {loading ? (
              <Card>
                <TableShimmer row={7} col={3} />
              </Card>
            ) : categoriesLists.length === 0 ? (
              <p className="my-3 text-center">{t("No categories found")}</p>
            ) : (
              <Card className="p-0">
                <CardBody className="p-0">
                  <Table className="table mb-0 " hover>
                    <thead className="table-light">
                      <tr>
                        <th className="text-start min_80">
                          <span className="d-inline-block py-2 px-2">
                            {t("Categories")}
                          </span>
                        </th>
                        <th className="text-start">
                          {(isTenantOwnerAdmin() ||
                            usersPermissions?.edit) && (
                            <span className="d-inline-block py-2">
                              {t("Status")}
                            </span>
                          )}
                        </th>
                        <th className="text-end">
                          <span
                            className="d-inline-block py-2 "
                            style={{
                              paddingInlineEnd: 20,
                              display: "block",
                            }}
                          >
                            {t("Action")}
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {categoriesLists.map(
                        ({ _id, name, nameAr, imageUrl, status, isCombo }) => (
                          <tr key={_id}>
                            <td className="text-start">
                              <div className="left_section ps-2">
                                <Link
                                  to={
                                    isCombo
                                      ? `/menus/combos/${_id}/items`
                                      : `/menus/categories/${_id}/items`
                                  }
                                >
                                  <div className="d-flex align-items-center">
                                    <img
                                      width={47}
                                      height={44}
                                      src={
                                        imageUrl ? imageUrl : placeholderImage
                                      }
                                      style={{ objectFit: "contain" }}
                                    />
                                    <h6
                                      className="cat_title in_line_one"
                                      style={{ margin: "0 16px" }}
                                    >
                                      {language === "sa"
                                        ? nameAr || "-"
                                        : name || "-"}
                                    </h6>
                                  </div>
                                </Link>
                              </div>
                            </td>
                            <td className="text-start">
                              {(isTenantOwnerAdmin() ||
                                usersPermissions?.edit) && (
                                <div style={{ marginTop: 10 }}>
                                  <Switch
                                    isChecked={status}
                                    disabled={_id === selectedId && isUpdating}
                                    onClickHandler={() =>
                                      handleStatusClick(_id, status)
                                    }
                                  />
                                </div>
                              )}
                            </td>
                            <td className="text-end">
                              <div
                                className="d-flex justify-content-end align-items-center pe-2"
                                style={{ marginTop: 10 }}
                              >
                                {(isTenantOwnerAdmin() ||
                                  usersPermissions?.edit) && (
                                  <>
                                    <i
                                      id={`edittooltip_${_id}`}
                                      onClick={() => {
                                        navigate(
                                          `/menus/categories/edit?id=${_id}`
                                        )
                                      }}
                                      className="mdi mdi-pencil font-size-18 text-success mx-2 cursor-pointer"
                                    ></i>
                                    <UncontrolledTooltip
                                      placement="top"
                                      target={`edittooltip_${_id}`}
                                    >
                                      {t("Edit")}
                                    </UncontrolledTooltip>
                                  </>
                                )}
                                {usersPermissions.list && (
                                  <>
                                    <i
                                      id={`viewtooltip_${_id}`}
                                      onClick={() => {
                                        navigate(
                                          `/menus/categories/category-details?id=${_id}`
                                        )
                                      }}
                                      className="mdi mdi-eye font-size-18 text-black mx-2 cursor-pointer"
                                    ></i>
                                    <UncontrolledTooltip
                                      placement="top"
                                      target={`viewtooltip_${_id}`}
                                    >
                                      {t("View")}
                                    </UncontrolledTooltip>
                                  </>
                                )}
                                {usersPermissions.delete && (
                                  <>
                                    <i
                                      id={`deletetooltip_${_id}`}
                                      onClick={e => {
                                        setItemIdToDelete(_id)
                                        setShowDeleteModal(true)
                                      }}
                                      className="bx bxs-trash font-size-18 mx-2 cursor-pointer"
                                      style={{ color: "#FD5F62" }}
                                    ></i>
                                    <UncontrolledTooltip
                                      placement="top"
                                      target={`deletetooltip_${_id}`}
                                    >
                                      {t("Delete")}
                                    </UncontrolledTooltip>
                                  </>
                                )}
                              </div>
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            )}
            {/* <Col xl={2} sm={6} key={_id}>
                   <Card className="full_height_card">
                    <CardBody>
                       <Link to={`/menus/categories/${_id}/items`}>
                         <img
                          src={imageUrl ? imageUrl : placeholderImage}
                          className="category_img item_image"
                        />
                      </Link>
                      <div className="inner d-flex align-items-center justify-content-between mt-3">
                        <Link
                          to={`/menus/categories/${_id}/items`}
                          className="title_a"
                        >
                          <h5 className="title in_2_line fs-6">{name}</h5>
                        </Link>
                        <div className="d-flex">
                          {usersPermissions.edit && (
                            <Switch
                              isChecked={status}
                              disabled={_id === selectedId && isUpdating}
                              onClickHandler={() =>
                                handleStatusClick(_id, status)
                              }
                            />
                          )}
                          <UncontrolledDropdown>
                            <DropdownToggle tag="a" className="card-drop">
                              <i className="mdi mdi-dots-vertical font-size-18"></i>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                              {usersPermissions.edit && (
                                <DropdownItem
                                  onClick={() => {
                                    navigate(`/menus/categories/edit?id=${_id}`)
                                  }}
                                >
                                  <i className="mdi mdi-pencil font-size-16 text-success me-1"></i>
                                  Edit
                                </DropdownItem>
                              )}
                              {usersPermissions.list && (
                                <DropdownItem
                                  onClick={() => {
                                    navigate(
                                      `/menus/categories/category-details?id=${_id}`
                                    )
                                  }}
                                >
                                  <i className="mdi mdi-eye font-size-16 text-primary me-1"></i>
                                  View
                                </DropdownItem>
                              )}
                              {usersPermissions.delete && (
                                <DropdownItem
                                  onClick={e => {
                                    setItemIdToDelete(_id)
                                    setShowDeleteModal(true)
                                  }}
                                >
                                  <i className="mdi mdi-trash-can font-size-16 text-danger me-1"></i>
                                  Delete
                                </DropdownItem>
                              )}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
               ))
            )} */}
            {!loading && (
              <Card>
                <CardBody>
                  <Paginations
                    data={categoriesLists}
                    itemsPerPage={itemsPerPage}
                    onPageChange={onPageChange}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    totalCount={totalCount}
                  />
                </CardBody>
              </Card>
            )}
            <div className="mb-3"></div>
          </Row>
        </div>
      </div>
      <ConfirmModal
        show={showStatusModal}
        onDeleteClick={confirmStatusUpdate}
        isLoading={isLoading}
        onCloseClick={() => {
          setSelectedCategory(null)
          setShowStatusModal(false)
        }}
        buttonText={t("Yes")}
        bodyTitle={t("Are you sure you want to update the status?")}
      />
      <DeleteModal
        show={showDeleteModal}
        onDeleteClick={handleDelete}
        isLoading={isLoading}
        onCloseClick={() => {
          setItemIdToDelete(null)
          setShowDeleteModal(false)
        }}
        buttonText={t("Delete")}
        bodyTitle={t("Are you sure you want to delete this {{name}}?", {
          name: t("Category"),
        })}
      />
    </>
  )
}

export default Categories
